(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('limValidate', limValidate);

    /* @ngInject */
    function limValidate() {
        var directive = {
            link: link,
            require: 'ngModel',
            restrict: 'A',
            scope: {
            }
        };
        return directive;

        function link(scope, element, attrs, ctrl) {
        }
    }
})();